/**
 * 3E · A oferta ao GESTOR: «Este aparelho tem N fichas de <nome> que não
 * chegaram ao banco. Trazer para você?». A regra e a explicação de segurança
 * moram em src/dados/adocao.ts.
 */
import { useEffect, useMemo, useState } from 'react'
import { adotar, procurarPresas } from '../dados/adocao'
import { usarEstado } from '../dados/armazem'
import { api, type Eu } from '../dados/sessao'
import { pode } from '../dominio/permissoes'
import { avisar } from '../ui'

export function OfertaDeAdocao({ eu }: { eu: Eu }) {
  const estado = usarEstado()
  const gestor = pode(eu.pessoa.papel, 'adotarFichas')
  // com sinal: a lista da equipe que o servidor devolve (só a da empresa do crachá)
  const [equipe, setEquipe] = useState<Set<string> | null>(null)
  const [dispensadas, setDispensadas] = useState<Set<string>>(() => new Set())
  useEffect(() => {
    if (!gestor) return
    let vivo = true
    api<{ pessoas: { id: string }[] }>('pessoas')
      .then((r) => { if (vivo) setEquipe(new Set((r.pessoas ?? []).map((p) => p.id))) })
      .catch(() => { /* sem sinal: vale a empresa gravada nos dados */ })
    return () => { vivo = false }
  }, [gestor, eu.pessoa.id])

  const grupos = useMemo(
    () => (gestor ? procurarPresas((id, conta) => (equipe ? equipe.has(id) : !!conta && conta === eu.conta.id)) : []),
    // `estado` muda depois de trazer: a oferta some sozinha
    [gestor, equipe, eu.conta.id, estado],
  )
  const mostrar = grupos.filter((g) => !dispensadas.has(g.pessoaId))
  if (!mostrar.length) return null

  return (
    <>
      {mostrar.map((g) => (
        <div className="tarja alerta nao-imprimir" key={g.pessoaId}>
          Este aparelho tem {g.fichas.length === 1 ? '1 ficha' : `${g.fichas.length} fichas`} de {g.nome} que não
          {g.fichas.length === 1 ? ' chegou' : ' chegaram'} ao banco
          {' '}(nº {g.fichas.map((f) => f.numero).join(', ')}). Trazer para você?
          <div className="mini-dica" style={{ fontWeight: 400 }}>
            Ela{g.fichas.length === 1 ? '' : 's'} passa{g.fichas.length === 1 ? '' : 'm'} a ser sua{g.fichas.length === 1 ? '' : 's'}, com número novo
            com a sua sigla, e sobe{g.fichas.length === 1 ? '' : 'm'} no seu «Sincronizar». Saem dos dados de {g.nome} neste aparelho.
          </div>
          <div className="linha" style={{ marginTop: 8 }}>
            <button className="mini" onClick={() => {
              const n = adotar(g)
              avisar(n ? `${n === 1 ? '1 ficha trazida' : `${n} fichas trazidas`} — vão no próximo Sincronizar` : 'Nada a trazer')
            }}>Trazer para mim</button>
            <button className="mini" onClick={() => setDispensadas(new Set([...dispensadas, g.pessoaId]))}>Agora não</button>
          </div>
        </div>
      ))}
    </>
  )
}
